// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1bb87ce4","667":"b8cacbf9"}[chunkId] + ".chunk.js";
};